var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"dense":"","required":"","outlined":"","autofocus":"","min":"0","type":"number","color":"secondary","value":_vm.value,"suffix":_vm.suffix,"label":_vm.$t(("form.labels." + _vm.title))},on:{"change":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }